import { Carousel } from 'primereact/carousel';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import BaseCard from './BaseCard.jsx';
import CircularProgress from './CircularProgress.jsx';
import { useNavigate } from 'react-router-dom';
import IconFilter from '../images/IconFilter';
import { formatNumbers } from '../../utils/formatNumbers.js';
import dayjs from 'dayjs';

const getItemLabel = (item) => {
    if (typeof item.all_day !== 'undefined') {
        return item.all_day === 1 ? 'All day meetings' : 'Scheduled meetings';
    }
    if (typeof item.follow_up !== 'undefined') {
        return item.follow_up === 1 ? 'Follow up' : 'No follow up';
    }
    if (typeof item.is_met !== 'undefined') {
        return item.is_met === 1 ? 'Is met' : 'Not met';
    }
    if (item.key) {
        return dayjs(item.key, 'YYYY-MM').format('MMMM YYYY');
    }
    if (item.period) {
        return dayjs(item.period, 'YYYY-MM').format('MMMM YYYY');
    }
    if (item.role) {
        return item.role;
    }
    if (item.category) {
        return item.category;
    }
    if (item.extension) {
        return item.extension;
    }
    return item.name;
};

const DashboardMetricsCarousel = ({
    className,
    items,
    page,
    total,
    clickAction,
    filterKey,
    displayMode = 'percentage',
    linkBase = '/contacts/advanced-search',
    transformFilter
}) => {
    const navigate = useNavigate();

    const handleCardClick = (item) => {
        if (clickAction === 'filter' && filterKey) {
            const filterValue = transformFilter
                ? transformFilter(item, filterKey)
                : [item.id !== undefined ? item.id : item.name];
            navigate(linkBase, {
                state: { filters: { [filterKey]: filterValue }, backRoute: window.location.pathname }
            });
        } else if (clickAction === 'search') {
            navigate(linkBase, {
                state: { search: item.name, backRoute: window.location.pathname }
            });
        }
    };

    const dashboardMetricTemplate = (item) => {
        return (
            <div className='mr-4'>
                <BaseCard
                    className={`mr-4 my-4 relative rounded-2xl shadow-mildSubtleRight ${displayMode === 'percentage' ? 'flex py-4 px-2 min-h-[190px]' : 'p-4 min-h-[80px]'}`}
                    onClick={clickAction ? () => handleCardClick(item) : undefined}
                >
                    {clickAction && <IconFilter className='fill-theme1-title2 absolute right-3 top-3 w-5 h-5' />}

                    {displayMode === 'percentage' ? (
                        <div className='w-full flex flex-col justify-center items-center text-center h-auto'>
                            <div className='text-theme1-title2 font-semibold text-base mt-auto leading-[20px] tracking-wide'>
                                {item.name}
                            </div>
                            <CircularProgress percentage={Math.round((item.count / total) * 100)} />
                        </div>
                    ) : (
                        <>
                            <div className='text-[50px] font-bold text-center text-theme1-gold'>
                                {formatNumbers(Number(item.count))}
                            </div>
                            <div className='w-full flex flex-col items-center justify-center'>
                                <div className='text-theme1-title2 font-bold text-center capitalize'>
                                    {getItemLabel(item)}
                                </div>
                            </div>
                        </>
                    )}
                </BaseCard>
            </div>
        );
    };

    return (
        <div className={twMerge('', className)}>
            <Carousel
                value={items}
                numScroll={1}
                numVisible={2}
                itemTemplate={dashboardMetricTemplate}
                showNavigators={false}
                circular={false}
                showIndicators
                page={page || 0}
            />
        </div>
    );
};

export default DashboardMetricsCarousel;
